import type { ReactNode } from "react";
import { AppShell } from "./AppShell";

export function PublicLayout({ children }: { children: ReactNode }) {
	return <AppShell mode="public">{children}</AppShell>;
}
